import React from "react";
import AuthNotSupported from "./pages/AuthNotSupported";
import Landing from "./pages/Landing";
import Features from "./pages/Features";
import Blog from "./pages/Blog";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

//Blogs
import IntroductionBlog from "./pages/Blogs/Introduction";
import Evolution from "./pages/Blogs/Evolution";
import OlympusGrid from "./pages/Blogs/OlympusGrid";
import MonumentalStep from "./pages/Blogs/MonumentalStep";

import { getCdnUrl } from "@cloudpremise/portal_core";

// Material Kit 2 PRO React components
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";

const date = new Date().getFullYear();

const routes = ({page, basename, history}) => {
    return [
        {
            route: "/",
            component: (
                <Landing history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/landing",
            component: (
                <Landing history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/features",
            component: (
                <Features history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/terms",
            component: (
                <Terms history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/privacy",
            component: (
                <Privacy history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/blogs",
            component: (
                <Blog history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/blog/introducing-olympus-grid",
            component: (
                <IntroductionBlog history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/blog/the-evolution-of-olympus-grid-perfection-in-enterprise-architecture",
            component: (
                <Evolution history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/blog/olympus-grid-the-future-of-enterprise-architecture-is-here",
            component: (
                <OlympusGrid history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/blog/olympus-grid-a-monumental-step-forward-in-cloud-enterprise-architecture",
            component: (
                <MonumentalStep history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth-not-supported",
            component: (
                <AuthNotSupported history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
    ];
};

const footerRoutes = (props) => {
    const { onLeadModal } = props;
    const cdnUrl = getCdnUrl();
    const logoCT = cdnUrl+"/assets/img/logo.png";
    return {
        brand: {
            name: '',
            image: logoCT,
            route: "/",
            inline: true
        },
        socials: [
            // {
            //     icon: <FacebookIcon />,
            //     link: "https://www.facebook.com/CreativeTim/",
            // },
            // {
            //     icon: <TwitterIcon />,
            //     link: "https://twitter.com/creativetim",
            // },
            // {
            //     icon: <GitHubIcon />,
            //     link: "https://github.com/creativetimofficial",
            // },
            // {
            //     icon: <YouTubeIcon />,
            //     link: "https://www.youtube.com/channel/UCVyTG4sCw-rOvB9oHkzZD1w",
            // },
        ],
        menus: [
            {
                name: "company",
                items: [
                    { name: "Blog", route: "/blog" },
                ],
            },
            {
                name: "Products",
                items: [
                    // { name: "Features", route: "/features" },
                    {name: "Demo", href: "https://olympus-grid-iris.netlify.app"}
                ],
            },
            {
                name: "help & support",
                items: [
                    { name: "contact us", href: "javascript:void(0);", onClick: (event) => {
                        event.preventDefault();
                        onLeadModal(true);
                    } },
                ],
            },
            {
                name: "legal",
                items: [
                    { name: "terms & conditions", route: "/terms" },
                    { name: "privacy policy", route: "/privacy" },
                ],
            },
        ],
        copyright: (
            <MDTypography variant="button" fontWeight="regular">
                All rights reserved. Copyright &copy; {date} Olympus-Grid by CloudPremise LLC
            </MDTypography>
        ),
    }
};

export { footerRoutes, routes };

export default routes;
